export enum ClasseTipoProcedimentoEnum {
  ADMINISTRATIVO = 'ADMINISTRATIVO',
  ADMINISTRATIVO_DISCIPLINAR = 'ADMINISTRATIVO_DISCIPLINAR',
  ADMINISTRATIVO_ELEITORAL = 'ADMINISTRATIVO_ELEITORAL',
  ATO_EXPEDIENTE = 'ATO_EXPEDIENTE',
  CARTA = 'CARTA',
  CAUTELAR = 'CAUTELAR',
  CONHECIMENTO = 'CONHECIMENTO',
  CONSTITUCIONAL = 'CONSTITUCIONAL',
  CONSULTA = 'CONSULTA',
  CUMPRIMENTO_SENTENCA_DECISAO = 'CUMPRIMENTO_SENTENCA_DECISAO',
  DIVERSOS = 'DIVERSOS',
  EMBARGOS_EXECUCAO = 'EMBARGOS_EXECUCAO',
  EXECUCAO_FISCAL = 'EXECUCAO_FISCAL',
  EXECUCAO_JUDICIAL = 'EXECUCAO_JUDICIAL',
  EXECUCAO_TITULO_EXTRAJUDICIAL = 'EXECUCAO_TITULO_EXTRAJUDICIAL',
  EXTINTO = 'EXTINTO',
  INCIDENTE_ADMINITRATIVO = 'INCIDENTE_ADMINITRATIVO',
  INCIDENTE_CUMPRIMENTO_SENTENCA_DECISAO = 'INCIDENTE_CUMPRIMENTO_SENTENCA_DECISAO',
  INCIDENTE_ESPECIAL = 'INCIDENTE_ESPECIAL',
  INCIDENTE_EXECUCAO = 'INCIDENTE_EXECUCAO',
  INCIDENTE_EXECUCAO_MANDADO_SEGURANCA = 'INCIDENTE_EXECUCAO_MANDADO_SEGURANCA',
  INCIDENTE_EXECUCAO_PENAL = 'INCIDENTE_EXECUCAO_PENAL',
  INCIDENTE_GERAL = 'INCIDENTE_GERAL',
  INDEFINIDO = 'INDEFINIDO',
  LIQUIDACAO = 'LIQUIDACAO',
  MEDIDA_GARANTIDORA = 'MEDIDA_GARANTIDORA',
  MEDIDA_PREPARATORIA = 'MEDIDA_PREPARATORIA',
  OUTRO = 'OUTRO',
  PRE_PROCESSUAL = 'PRE_PROCESSUAL',
  PROCESIMENTO_INVESTIGATORIO = 'PROCESIMENTO_INVESTIGATORIO',
  RECLAMACAO = 'RECLAMACAO',
  RECURSO_ADMINISTRATIVO = 'RECURSO_ADMINISTRATIVO',
  RECURSO_ADMINISTRATIVO_DISCIPLINAR = 'RECURSO_ADMINISTRATIVO_DISCIPLINAR',
  RECURSO_CAUTELAR = 'RECURSO_CAUTELAR',
  RECURSO_CONHECIMENTO = 'RECURSO_CONHECIMENTO',
  RECURSO_INTERNO_CAUTELAR = 'RECURSO_INTERNO_CAUTELAR',
  RECURSO_INTERNO_CONHECIMENTO = 'RECURSO_INTERNO_CONHECIMENTO',
  RECURSO_INTERNO_EXECUCAO = 'RECURSO_INTERNO_EXECUCAO',
  RECURSO_MEDIDA_GARANTIDORA = 'RECURSO_MEDIDA_GARANTIDORA',
  RECURSO_OUTRA_INSTANCIA = 'RECURSO_OUTRA_INSTANCIA',
  RESTAURACAO = 'RESTAURACAO',
  SUMULA = 'SUMULA',
  SUSPENSAO = 'SUSPENSAO',
  TUTELA_ANTECEDENTE = 'TUTELA_ANTECEDENTE'
}
